import { FunctionComponent } from 'react';
import { ScheduleListSubscriber } from '@cbridge-packages/schedule';
import { DictTimezoneListSubscriber } from '@cbridge-packages/dict-timezones';
import { ProfilesLayout } from '../../_layout/ProfilesLayout';

export const ProfilesScheduleLayout: FunctionComponent = () => {
  return (
    <ProfilesLayout>
      <ScheduleListSubscriber />
      <DictTimezoneListSubscriber />
    </ProfilesLayout>
  );
};
